@let info = selectedAccount() || account();
@if (info) {
  @let isMultipleLocations = (groupAccounts() || []).length > 1;
  <app-map-info-window-wrapper (closeEvent)="closeEvent.emit()">
    <ng-container header-left-pane>
      <div class="d-flex align-items-center">
        <div
          class="overflow-hidden flex-fill d-flex justify-content-between align-items-center"
          #tooltipTarget
        >
          <a
            class="rmv-link rmv-link--base rmv-text-dots"
            href="/accounts/{{ info.fbId }}/details"
            target="_blank"
          >
            <b
              [ngbTooltip]="info.name"
              container="body"
              placement="top"
              [positionTarget]="tooltipTarget"
            >{{ info.name }}
              @if (isMultipleLocations) {
                ({{ selected() + 1 }})
              }
            </b>
          </a>
        </div>
        <div class="ms-2">
          <app-sla-details
            [timestamp]="info.completedStop"
            [scope]="info.scope"
            [slaRange]="slaRange()"
            iconSize="20px"
          ></app-sla-details>
        </div>
      </div>
    </ng-container>
    <ng-container header-right-pane>
      @if (isMultipleLocations) {
        <app-button
          class="--only-icon --small --primary-dark"
          icon="rmv-icon-ic-arrow-right"
          (clickEvent)="onNext()"
        ></app-button>
      }
    </ng-container>

    <div class="__container d-flex flex-column">
      @if (info.accountType; as accountType) {
        <div class="d-flex">
          <app-tag class="--category --compact overflow-hidden" [color]="accountType.color">{{ accountType.title }}</app-tag>
        </div>
      }

      <hr class="__hr rmv-hr">

      <div>
        <app-summary-item icon="rmv-icon-location" tooltipText="Address">
          <div class="d-flex">
            <a
              class="rmv-link rmv-text-dots"
              target="_blank"
              href="https://www.google.com/maps/search/?api=1&query={{ info.geoDetails.location?.coordinates?.[1] }},{{ info.geoDetails.location?.coordinates?.[0] }}"
            >
              {{ info.geoDetails.address }}
            </a>
            <a class="rmv-link __address-link" target="_blank"
               href="https://www.google.com/search?q={{ info.geoDetails.address | encodeUrl }}">
              <img class="rmv-icon-middle-size" src="/assets/images/google-logo.svg" alt="google logo"/>
            </a>
          </div>
        </app-summary-item>
      </div>

      <div class="d-flex __info-summary">
        <app-summary-item icon="rmv-icon-expence-v2" iconBgColor="#06BB7940" tooltipText="Open Deals">
          @if (dealStatsLoading()) {
            <span class="rmv-text-neutral-color rmv-text-sm">Loading...</span>
          } @else {
            @if (dealOpenStats(); as stats) {
              {{ stats.totalAmount || 0 | formatAmount }}
            } @else {
              $0.00
            }
          }
        </app-summary-item>
        @if (!dealStatsLoading()) {
          <div class="__deal-summary-item">
            <app-summary-item icon="rmv-icon-won-deals" iconBgColor="#F1D26040" tooltipText="Won Deals">
              @if (dealWonStats(); as stats) {
                {{ stats.totalAmount || 0 | formatAmount }}
              } @else {
                $0.00
              }
            </app-summary-item>
          </div>
          <div class="__deal-summary-item">
            <app-summary-item icon="rmv-icon-lost-deals" iconBgColor="#FF585840" tooltipText="Lost Deals">
              @if (dealLostStats(); as stats) {
                {{ stats.totalAmount || 0 | formatAmount }}
              } @else {
                $0.00
              }
            </app-summary-item>
          </div>
        }
      </div>

      @let tags = info.tags;
      @if (tags && tags.length > 0) {
        <div class="__info-summary">
          <app-summary-item icon="rmv-icon-bob-tags" tooltipText="Tags">
            <app-tag-list class="--break-text --v2" [tags]="tags" [compact]="true"></app-tag-list>
          </app-summary-item>
        </div>
      }
    </div>

    <ng-container footer>
      <div class="d-flex justify-content-between">
        @if (info.users) {
          <app-account-v2-users
            [users]="info.users"
            [primaryUserId]="info.primaryUserId"
            target="_blank"
          ></app-account-v2-users>
        }
        @if (isNotBelongsToCurrentUser()) {
          <app-button
            class="--primary --middle"
            icon="rmv-icon-ic-plus"
            [cdkMenuTriggerFor]="menu"
            [loading]="assignToMeUpdating()"
          ></app-button>
        }
      </div>
    </ng-container>

  </app-map-info-window-wrapper>
}

<ng-template #menu>
  <div class="rmv-dropdown-menu" cdkMenu>
    <button
      type="button"
      class="rmv-dropdown-menu__button"
      (click)="assignToMe()"
      cdkMenuItem
    >Assign to me
    </button>
  </div>
</ng-template>
